import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, SetAuthPayload } from './types';

const initialState: AuthState = {
  token: null,
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<SetAuthPayload>) {
      console.log('[Auth Reducer] setAuth called with payload:', {
        tokenLength: action.payload.token?.length,
        tokenPreview: action.payload.token ? `${action.payload.token.substring(0, 30)}...` : 'null',
        user: action.payload.user
      });
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
    },
    clearAuth(state) {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
    },
    setAuthError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAuthLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const { setAuth, clearAuth, setAuthError, setAuthLoading } = authSlice.actions;
export default authSlice.reducer;
